import { render, staticRenderFns } from "./GrantCardOpenBak2.vue?vue&type=template&id=6c9add69"
import script from "./GrantCardOpenBak2.vue?vue&type=script&lang=js"
export * from "./GrantCardOpenBak2.vue?vue&type=script&lang=js"
import style0 from "./GrantCardOpenBak2.vue?vue&type=style&index=0&id=6c9add69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports